/* unplugin-vue-components disabled */import script from "./SourceBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./SourceBlock.vue?vue&type=script&lang=ts&setup=true"

import "./SourceBlock.vue?vue&type=style&index=0&id=be18beb2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be18beb2"]])

export default __exports__